// Company info lives in the sidebar for this brand, so pages without a
// player bar render no footer.
export const Default = () => null;
